import { api } from 'utility';
import { getNumberOfServiceProviderCallsUrl, getServiceSetProviderUrl } from 'URLs';
class ServiceProviderServices {
  getServiceProviders(data, params) {
    return api.post(getNumberOfServiceProviderCallsUrl(), data, { params });
  }

  getServiceSetProviders(serviceSetId, data, params) {
    return api.post(getServiceSetProviderUrl(serviceSetId), data, { params });
  }
}

export default new ServiceProviderServices();
